
import React from 'react';

const SiteOfficeBackground = () => {
  return (
    <div className="absolute inset-0 w-full" aria-hidden>
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-sky-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob" />
      <div className="absolute top-3/4 right-1/4 w-96 h-96 bg-sky-300 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000" />
      <div className="absolute bottom-1/4 left-1/2 w-96 h-96 bg-slate-200 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000" />
      <div
        className="absolute inset-0 bg-gradient-to-r from-sky-50/20 to-slate-50/20"
        style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(14, 165, 233, 0.12) 1px, transparent 0)`,
          backgroundSize: '20px 20px',
        }}
      />
    </div>
  );
};

export default SiteOfficeBackground;
